mtl.alloy.factory['display-in-modal'] = (function($) {
    'use strict';

    return function(element, options) {

        if(app.breakpoint.not('phone-s phone-l tablet-s'))
        {
            $(element).on('click', function(event){
            	event.preventDefault();

            	var $href = $(this).attr('href');

                var arr = $href.split('?');
                if (arr.length > 1 && arr[1] !== '') {
                    $href += "&modal=true";
                } else {
                    $href += "?modal=true";
                }
            	
            	$.fancybox({
            		type: 'ajax',
            		href: $href,
                    afterShow: function(current, previous) {
                        mtl.alloy.process($('.fancybox-inner'));
                    }
            	});
            });
        }

        // $("[data-init='display-image-in-modal']").fancybox();
    }

}($));
